import {
  GET_SOURCES_GLOBAIS_INIT,
  GET_SOURCES_GLOBAIS_SUCCESS,
  UPDATE_SOURCE_GLOBAL_ATIVO_INIT,
  UPDATE_SOURCE_GLOBAL_ATIVO_SUCCESS,
  ERROR_SOURCES_GLOBAIS_MSG,
  CLEAR_FLAGS_SOURCES_GLOBAIS
} from '../actionTypes';

const INIT_STATE = {
  globalAtivo: { pgfarma: false, iqvia: false, closeup: false } as { pgfarma: boolean; iqvia: boolean; closeup: boolean },
  loading: false,
  loadingSave: false,
  isUpdated: false,
  isError: false,
  msg: ''
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case GET_SOURCES_GLOBAIS_INIT:
      return { ...state, loading: true };
    case GET_SOURCES_GLOBAIS_SUCCESS: {
      const { globalAtivo } = action.payload;
      return { ...state, loading: false, globalAtivo };
    }
    case UPDATE_SOURCE_GLOBAL_ATIVO_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false, msg: '' };
    case UPDATE_SOURCE_GLOBAL_ATIVO_SUCCESS: {
      const { msg } = action.payload;
      return { ...state, loadingSave: false, isUpdated: true, msg };
    }
    case ERROR_SOURCES_GLOBAIS_MSG: {
      const { msg } = action.payload;
      return { ...state, loading: false, loadingSave: false, isError: true, msg };
    }
    case CLEAR_FLAGS_SOURCES_GLOBAIS:
      return { ...state, isUpdated: false, isError: false, loadingSave: false, msg: '' };
    default:
      return { ...state };
  }
};
